module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-packet-entity-button"
  }, [_c('ModalReveal', {
    key: _vm._uid,
    ref: "editPacketModal"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit packet")]), _c('PacketForm', {
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  }), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.edit
    },
    slot: "footer"
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30afe635!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/EditPacketReveal.vue
// module id = 2373
// module chunks = 1